import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Tooltip } from "antd";
import { Row } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import SearchIcon from "../../image/SearchIcon.svg";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";

const { Search } = Input;

const ArchiveFloatRFQAssignPR = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ArchiveFloatRFQAssignPR, setArchiveFloatRFQAssignPR] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  const categoryId = id;
  useEffect(() => {
    const getArchiveFloatRFQAssignPR = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(`purchase-requisition-restore/?company_id=${CompanyId}`, state);
        if (apiResponse.status) {
          setArchiveFloatRFQAssignPR(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_assign_purchase_requisition"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getArchiveFloatRFQAssignPR();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "pr_number" && sortOrder === "ascend") {
      sortingEnumKey = "pr_number";
    }
    if (sortField === "pr_number" && sortOrder === "descend") {
      sortingEnumKey = "-pr_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }

    try {
      let apiResponse = await postRequest("purchase-requisition-restore/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("assign_purchase_requisition_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
        navigate(`/request-for-quotation/float-rfq-assign-pr/${categoryId}`);
      } else {
        ErrorNotificationMsg(t("error_in_restore_assign_purchase_requisition"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  useEffect(() => {
    // Fetch currency symbol from API
    const getCurrency = async () => {
      try {
        const response = await getRequest("business-settings/get-currency-by-business-setting/");
        setCurrencySymbol(response.data.data); // Assuming the response contains the currency symbol in the 'data' field
      } catch (error) {
        console.error("Error fetching currency symbol:", error);
      }
    };

    // Call getCurrency to fetch currency symbol when needed
    getCurrency(); // Replace 'data' with appropriate data parameter for your API call
  }, []); // Empty dependency array ensures this effect runs only once after the initial render

  const columns = [
    {
      title: "category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
    },
    {
      title: "PR Creator",
      dataIndex: "pr_creator",
      key: "pr_creator",
    },
    {
      title: "Assigned Buyer",
      dataIndex: "pr_approval_by",
      key: "pr_approval_by",
    },
    {
      title: "PR Number",
      dataIndex: "pr_number",
      key: "pr_number",
    },
    // {
    //   title: "Approval Date",
    //   dataIndex: "pr_approval_date",
    //   key: "pr_approval_date",
    // },
    // {
    //   title: "Estimated PR Value",
    //   dataIndex: "total_amount",
    //   key: "total_amount",
    // },
    {
      title: `Estimated PR Value (${currencySymbol})`,
      dataIndex: "total_amount",
      key: "total_amount",
      sorter: true,
      render: (value) => <span>{currencySymbol} {value}</span>
      //render: (value) => <span> ₹ {value} </span>,
    },

    //   {
    //     title: "Assign to buyer",
    //     width: "160px",
    //     dataIndex: "pr_assign_to_buyer",
    //     key: "pr_assign_to_buyer",
    //     render: (_, record) => (
    //       <Select
    //         // defaultValue={uomOptions.length > 0 ? uomOptions[0].value : ''}
    //         // defaultValue=""
    //         defaultValue={record.pr_assign_to_buyer}
    //         style={{ width: 120 }}
    //         onChange={(value) => handleAssignToBuyerChange(value, record)}
    //       >
    //         {assignBuyer.map((option) => (
    //           <Select.Option key={option.employee_id} value={option.employee_id}>
    //             {option.first_name}
    //           </Select.Option>
    //         ))}
    //       </Select>
    //     ),
    //   },
    {
      title: "RFQ Status",
      dataIndex: "pr_status_for_rfq",
      key: "pr_status_for_rfq",
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Access archived assignments of purchase requisitions.
                  Archived entries retain historical data and can be restored if necessary.
                </span>
              }
            >
              <h3>{t("pl_archive_float_rfq")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/request-for-quotation/float-rfq-assign-pr/${id}`}>Assign Purchase Requisition</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_Archive")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("pl_company_address")}</h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>


          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={ArchiveFloatRFQAssignPR}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() =>
                navigate(
                  `/request-for-quotation/float-rfq-assign-pr/1`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchiveFloatRFQAssignPR;
